<template>
	<!-- Form -->
	<j-card class="xs-12 bg5 r2 p4">
		<!-- Email -->
		<core-form-input
			componentName="j-base-input-text"
			name="email"
			v-validate="{ required: true, email: true }"
			:validationErrors="errors"
			:label="$t('email')"
			v-model="form1.email"
		/>

		<!-- Role -->
		<core-form-input
			class="mt6"
			componentName="core-select-role"
			name="role"
			v-validate="'required'"
			:label="$t('select_role')"
			:validationErrors="errors"
			v-model="form2.role"
		/>

		<!-- ClientId -->
		<core-form-input
			class="mt6"
			componentName="j-base-select"
			:options="clientOptions"
			name="clientId"
			v-validate="'required'"
			:label="'Select Client ID'"
			:validationErrors="errors"
			v-model="form2.clientId"
		/>

		<!-- Internal Code -->
		<core-form-input
			class="mt6"
			componentName="j-base-input-text"
			name="internalCode"
			v-validate="{ required: true }"
			:validationErrors="errors"
			:label="$t('internal_code')"
			v-model="form1.internalCode"
		/>

		<!-- English First Name -->
		<core-form-input
			class="mt6"
			componentName="j-base-input-text"
			name="firstName"
			v-validate="{ required: true }"
			:validationErrors="errors"
			:label="$t('english_first_name')"
			v-model="form1.englishFirstName"
		/>

		<!-- English Last Name -->
		<core-form-input
			class="mt6"
			componentName="j-base-input-text"
			name="lastName"
			v-validate="{ required: true }"
			:validationErrors="errors"
			:label="$t('english_last_name')"
			v-model="form1.englishLastName"
		/>

		<!-- Chinese First Name -->
		<core-form-input
			class="mt6"
			componentName="j-base-input-text"
			name="chineseFirstName"
			:label="$t('chinese_first_name')"
			v-model="form1.chineseFirstName"
		>
			<span slot="label" class="fs3 c6">({{ $t("optional") }})</span>
		</core-form-input>

		<!-- Chinese Last Name -->
		<core-form-input
			class="mt6"
			componentName="j-base-input-text"
			name="chineseLastName"
			:label="$t('chinese_last_name')"
			v-model="form1.chineseLastName"
		>
			<span slot="label" class="fs3 c6">({{ $t("optional") }})</span>
		</core-form-input>

		<!-- Button -->
		<div class="flex xs-12 xs-between mt6">
			<j-button @click="inviteInternal" :isLoading="isLoading">{{
				$t("create_user")
			}}</j-button>
			<j-button
				type="bordered"
				@click="$router.push({ name: 'UsersManagement' })"
				>{{ $t("cancel") }}</j-button
			>
		</div>
	</j-card>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import crmConfig from "@/config/"
import api from "../../api/"

export default {
	components: {
		CoreFormInput,
		JCard,
		JButton
	},

	data: () => ({
		isLoading: false,
		form1: {
			englishFirstName: null,
			englishLastName: null,
			chineseFirstName: null,
			chineseLastName: null,
			email: null,
			internalCode: null
		},
		form2: {
			role: null,
			clientId: null
		},
		clientOptions: [
			{ name: "CRM", value: "covergo_crm" },
			{ name: "Agent Portal", value: "agentPortal" },
			{ name: "Broker Portal", value: "brokerPortal" }
		]
	}),

	methods: {
		async inviteInternal() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			const tenantId = this.$store.state.tenantId
			const clientId = this.form2.clientId

			this.isLoading = true
			const res = await api.inviteInternal({
				clientId,
				inviteInternalInput: { ...this.form1 }
			})
			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// When user is created, assign him a role
			const loginId = res.data.inviteInternal.id

			this.isLoading = true
			const res2 = await api.assignRole({
				loginId,
				permissionGroupId: this.form2.role
			})
			this.isLoading = false

			if (res2.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// Success
			this.$store.dispatch("addMessage", {
				message: { type: "success", text: this.$t("user_invited") }
			})

			this.$router.push({ name: "UsersManagement" })
		}
	}
}
</script>
